import { useState, useEffect } from "react";

const useFetch = (url) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(url)
      .then((res) => res.json())
        .then((data) => {
            if (data.errors !== null && data.errors !== "") alert(data.errors)
            setData(data.message)
        });
  }, [url]);

  return [data];
};

export default useFetch;